/* Zoom hover HD — Prolife International */

(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function getZoomSrc(img) {
    if (!img) return '';

    var srcset = img.getAttribute('srcset') || '';

    if (!srcset) {
      return img.currentSrc || img.src || '';
    }

    var candidates = srcset.split(',').map(function (candidate) {
      var parts = candidate.trim().split(/\s+/);
      return {
        url: parts[0],
        width: parseInt(parts[1], 10) || 0
      };
    }).filter(function (candidate) {
      return candidate.url && candidate.width;
    });

    if (!candidates.length) {
      return img.currentSrc || img.src || '';
    }

    candidates.sort(function (a, b) {
      return a.width - b.width;
    });

    var selected = candidates.find(function (candidate) {
      return candidate.width >= 1240;
    });

    return (selected || candidates[candidates.length - 1]).url;
  }

  function initZoom() {
    var mediaItems = document.querySelectorAll(
      '.m-main-product .m-product-media--desktop ' +
      '.m-product-media--item[data-media-type="image"]'
    );

    mediaItems.forEach(function (item) {
      if (item.dataset.prolifeZoomInitialized) return;
      item.dataset.prolifeZoomInitialized = 'true';

      var mainImg = item.querySelector('img');
      if (!mainImg) return;

      var layer = document.createElement('div');
      layer.className = 'prolife-zoom-layer';
      item.appendChild(layer);

      var imageLoaded = false;
      var imageLoading = false;
      var lastX = 50;
      var lastY = 50;
      var pointerInside = false;

      function loadZoomImage() {
        if (imageLoaded || imageLoading) return;

        var zoomSrc = getZoomSrc(mainImg);
        if (!zoomSrc) return;

        imageLoading = true;

        var preload = new Image();

        preload.onload = function () {
          layer.style.backgroundImage = 'url("' + zoomSrc + '")';
          imageLoaded = true;
          imageLoading = false;

          if (pointerInside) {
            layer.style.backgroundPosition = lastX + '% ' + lastY + '%';
            item.classList.add('prolife-zoom-active');
          }
        };

        preload.onerror = function () {
          imageLoading = false;
        };

        preload.src = zoomSrc;
      }

      function updatePosition(e) {
        var rect = item.getBoundingClientRect();

        lastX = ((e.clientX - rect.left) / rect.width) * 100;
        lastY = ((e.clientY - rect.top) / rect.height) * 100;

        if (!imageLoaded) return;

        layer.style.backgroundPosition = lastX + '% ' + lastY + '%';
        item.classList.add('prolife-zoom-active');
      }

      item.addEventListener('mouseenter', function () {
        pointerInside = true;
        loadZoomImage();
      });

      item.addEventListener('mousemove', updatePosition);

      item.addEventListener('mouseleave', function () {
        pointerInside = false;
        item.classList.remove('prolife-zoom-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initZoom);
  document.addEventListener('shopify:section:load', initZoom);
})();